<template>
  <b-form @submit.prevent="onSubmit">
    <b-form-row>
      
      <b-col md="6">
        <b-form-group label="Contrasena:">
          <b-form-input type="password" name="password" id="password" v-model="$v.password.$model" :state="validateField($v.password)"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Confirmar contraseña:">
          <b-form-input type="password" name="password-confirm" id="password-confirm" v-model="$v.passwordConfirm.$model" :state="validateField($v.passwordConfirm)"></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="12" class="text-right">
        <b-button variant="ow-primary"
          :disabled="saving"
          type="submit"
        >
          Guardar
        </b-button>
      </b-col>
      
    </b-form-row>
  </b-form>
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";

export default {
  props: {
    user: {
      type: Object,
      default: () => null
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      password: '',
      passwordConfirm: '',
    }
  },
  validations: {
    password: { required },
    passwordConfirm: { required, sameAs: sameAs('password') }
  },
  mounted() {
    
  },
  methods: {
    onSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return;
      }

      this.$emit('change', {
        password: this.password,
        password_confirmation: this.passwordConfirm
      })
    }
  }
}
</script>
